<tui-root>
  <!--
	<app-layout>
	<router-outlet></router-outlet>
	<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
		<p style="color: white">Please Wait. </p>
	</ngx-spinner>

</app-layout>-->

  <router-outlet></router-outlet>
</tui-root>
